import { render, staticRenderFns } from "./confirmer.vue?vue&type=template&id=4b7642fd&scoped=true"
import script from "./confirmer.vue?vue&type=script&lang=js"
export * from "./confirmer.vue?vue&type=script&lang=js"
import style0 from "./confirmer.vue?vue&type=style&index=0&id=4b7642fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7642fd",
  null
  
)

export default component.exports